// This script handles the full height cover header image
var coverContainer = document.getElementById("ln-cover");
jQuery(document).ready(function () {

	if (typeof(coverContainer) != 'undefined' && coverContainer != null) {
		reSizeHeader(); // set initial size
		window.addEventListener('resize', reSizeHeader, false);
	}

});


// handles the resizing of the background so that it always fills the space
function reSizeHeader() {
	jQuery('#ln-cover .header-text').css('minHeight', window.innerHeight + 'px');
}

